import React from 'react';
import parse from 'html-react-parser';
import { socialCardKeys } from 'src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors, cardColors } from 'src/constants/wall.constant';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'
import ClassNames from 'src/components/componentHelper/ClassNames';

const ReviewPictureCard = ({cardWidth, cardItem, fontStyle, darkModeEnabled, cardFontColor, cardBackgroundObject, ratingColor, darkCardTheme, linkColor, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled }) => {

    return (
        <div 
        className="px-6 mx-auto border shadow-md rounded-xl py-4 text-center" 
        style={
          darkModeEnabled? 
            { ...(cardBackgroundObject?cardBackgroundObject:{}),maxWidth:'40rem',minWidth:'100%', boxShadow:'5px 10px 5px -3px rgb(0 0 0 / 10%), 0px 4px 46px -2px rgb(0 0 0 / 5%)' }:
            {...(cardBackgroundObject?cardBackgroundObject:{}),maxWidth:'40rem',minWidth:'100%', boxShadow:'5px 10px 5px -3px rgb(0 0 0 / 10%), 0px 4px 46px -2px rgb(0 0 0 / 5%)' }
        }
        >
      
      <div
       className={ClassNames("mb-12 md:mb-0",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')}
      
       >
    
  
        <a className="text-lg font-bold mb-4 cursor-pointer" href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), lineHeight: 1.2, textDecoration: 'none' } : { color: (cardFontColor || textColors.light.primary), lineHeight: 1.2, textDecoration: 'none' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
          {cardItem[socialCardKeys.authorName]}
        </a>
        
    { (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='')  &&  <a className={!darkModeEnabled ? 'text-gray-700 mt-2 block' : 'text-gray-300 mt-2 block'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a> }

        <p className="mt-2 mb-2 tweet-content content" style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.15rem":"1.0rem",lineHeight: !smallSize? 1.5: 1.7 }}>
         
          {
               (cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!=='') &&
               <>
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="quote-left"
            className="w-6 pr-2 text-gray-500 inline-block" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="currentColor"
              d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z">
            </path>
          </svg>
               <div className="content mb-3" dir="auto">
               {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent])
                  :
                  null
               }
               </div>
               </>
               }
               {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full" >

                     <img className="w-auto rounded-md " onLoad={()=>refresh()} loading='lazy' style={{ width: '100%', borderRadius:'8px', objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="Post Preview" />

                  </div>
               }
        </p>

      
        {
           (cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0) ?
                <ul className="flex justify-center mb-4">
                   {
                     [...Array(Math.min(5,Math.floor(cardItem[socialCardKeys.starRating])))].map((e,i) =>
                   <li key={e}>
                     <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}}
                       role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                       <path fill="currentColor"
                         d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z">
                       </path>
                     </svg>
                   </li>
                     )
                   }
                   {
                    (cardItem[socialCardKeys.starRating]%1===0.5) &&
                       <li>
                       <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star-half-alt"
                         className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}} role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 512">
                         <path fill="currentColor"
                           d="M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z">
                         </path>
                       </svg>
                     </li>
                   }

                 </ul>
                 :
                 null
                 
          }

      { (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ?
      <div className="mb-4" style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary), fontSize: 13 } : { color: (cardFontColor || textColors.light.secondary), fontSize: 13 }}>{dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY')}</div>
      :
      null
      }

      </div>
      


</div>
    );
};

export default ReviewPictureCard;